module.exports = __webpack_public_path__ + "img/bg.3e5c8e61.jpg";